// extracted by mini-css-extract-plugin
module.exports = {"createButton":"CreateDomain_createButton__JbQxB","buttonsContainer":"CreateDomain_buttonsContainer__3GNky"};